import * as TRANSLATIONS from '../assets/i18n/en-US.json';

export const enum LoginStep {
    sendEmail = 'sendEmail',
    sendRegistrationCode = 'sendRegistrationCode',
    postRegistrationCode = 'postRegistrationCode'
}

export const enum SearchParamName {
    page_id = 'page_id',
    token = 'token',
    // event_token = 'event_token',
    // TODO: These are no longer used - we changed impersonation to use URL link token named just 'token'
    // event_token_refresh = 'event_token_refresh',
    // event_token_expires = 'event_token_expires',
    clear = 'clear',
    transaction_status = 'transaction_status',
    decline = 'decline',
    featureFlagProfile = 'featureflag-profile',
    openProfilePage = 'open-profile-page',
    utm = 'utm',
    useSessionStorage = 'use-session-storage',
    identity = 'identity',
    impersonated = 'impersonated',
}

export const enum TransactionStatus {
    paid = 'paid',
    cancelled = 'cancelled'
}

export const SearchParamValue = {
    [SearchParamName.clear]: {
        true: 'true',
        event: 'event'
    }
};

// export const enum HashPrefix {
//     openProfile = '#open-profile-'
// }

export const enum ContentLoadStateName {
    loading = 'loading',
    loaded = 'loaded',
    error = 'error'
}

export const enum SpecialPageId {
    azaForm = 'aza-form'
}

export const enum IntegrationType {
    googleTagManager = 'google-tag-manager',
    googleAnalytics = 'google-analytics',
    javascript = 'javascript',
    custom = 'custom',
    tealium = 'tealium'
}

export const enum MergetagFieldType {
    participant = 'participant',
    event = 'event'
}

export const enum ClassName {
    azaDisabledButton = 'aza-disabled-button',
    regAppErrorContent = 'reg-app-error-content',
    azaInputField = 'aza-input-field',
    azaInputTypeMultiSelectCheckboxes = 'aza-input-type-multi-select-checkboxes',
    azaInputTypeSelectRadioButtons = 'aza-input-type-select-radiobuttons',
    azaLinkLogout = 'aza-link-logout',
    azaOpinionScaleSelectedValue = 'aza-opinion-scale-selected-value',
    azaRatingVisibleItem = 'aza-rating-visible-item',
    azaRatingNotVisibleItem = 'aza-rating-not-visible-item',
    noScroll = 'no-scroll',
    azaLockedDocumentFieldNoDocumentUploaded = 'aza-locked-document-field-no-document-uploaded',
    azaDocumentFieldAttachButtonContainerNoDocumentUploaded = 'aza-document-field-attach-button-container-no-document-uploaded',
}

export const enum GoogleTagManagerEvent {
    formSubmit = 'azavista_form_submit',
    pageView = 'azavista_website_page_view'
}

export const enum TealiumEvent {
    formSubmit = 'form-submit',
    pageView = 'page-load'
}

export const enum ServerErrorCode {
    invalidEventToken = 'InvalidEventToken',
    emailConflict = 'EmailConflict'
}

export const enum TranslationKey {
    noDocument = 'NO_DOCUMENT',
    suppliedCodeIsNoLongerValid = 'SUPPLIED_CODE_IS_NO_LONGER_VALIED',
    unknownErrorOccured = 'UNKNOWN_ERROR_OCCURED',
    accessDenied = 'ACCESS_DENIED',
    cannotLoadPage = 'CANNOT_LOAD_PAGE',
    yourFormHasBeenSubmitted = 'YOUR_FORM_HAS_BEEN_SUBMITTED',
    orderAmount = 'ORDER_AMOUNT',
    refundAmountIs = 'REFUND_AMOUNT_IS',
    cancellationPolicy = 'CANCELLATION_POLICY',
    doYouWantToCancel = 'DO_YOU_WANT_TO_CANCEL',
    back = 'BACK',
    ok = 'OK',
    cancelback = 'CANCELBACK',
    cancelok = 'CANCELOK',
    cannotUpdateTheParticipant = 'CANNOT_UPDATE_THE_PARTICIPANT',
    cannotGenerateNewTokens = 'CANNOT_GENERATE_NEW_TOKENS',
    cannotCreateTheParticipant = 'CANNOT_CREATE_THE_PARTICIPANT',
    errorOccuredOnImageUpload = 'ERROR_OCCURED_ON_IMAGE_UPLOAD',
    errorOccuredOnFileUpload = 'ERROR_OCCURED_ON_FILE_UPLOAD',
    cannotUploadImageForField = 'CANNOT_UPLOAD_IMAGE_FOR_FIELD',
    cannotFindFieldWithId = 'CANNOT_FIND_FIELD_WITH_ID',
    myProfile = 'MY_PROFILE',
    myEvents = 'MY_EVENTS',
    myOrders = 'MY_ORDERS',
    changePassword = 'CHANGE_PASSWORD',
    profileUpdatedSuccessfully = 'PROFILE_UPDATED_SUCCESSFULLY',
    invalidToken = 'INVALID_TOKEN',
    unknownPaymentProvider = 'UNKNOWN_PAYMENT_PROVIDER',
    youAreNotRegisteredCannotCancel = 'YOU_ARE_NOT_REGISTERED_CANNOT_CANCEL',
    logout = 'LOGOUT',
    selectQuantityForAtLeastOneOfTheFollowingProducts = 'SELECT_QUANTITY_FOR_AT_LEAST_ONE_OF_THE_FOLLOWING_PRODUCTS',
    events = 'EVENTS',
    requests = 'REQUESTS',
    myOrganization = 'MY_ORGANIZATION',
    invalidEmail = 'INVALID_EMAIL',
    anInvitationHasBeenSent = 'INVITATION_HAS_BEEN_SENT',
    oneOrMoreMandatoryFieldsHaveNotBeenCompleted = 'ONE_OR_MORE_MANDATORY_FIELDS_HAVE_NOT_BEEN_COMPLETED',
    liked = 'LIKED',
    notLiked = 'NOT_LIKED',
    registered = 'REGISTERED',
    notRegistered = 'NOT_REGISTERED',
    subscriptions = 'SUBSCRIPTIONS',
    saved = 'SAVED',
    payByInvoice = 'PAY_BY_INVOICE',
    payOnline = 'PAY_ONLINE',
    paymentTypeIsNotSelected = 'PAYMENT_TYPE_IS_NOT_SELECTED',
    selectPaymentType = 'SELECT_PAYMENT_TYPE',
    itIsMandatoryToSelectAtLeastOneActivityOrSession = 'IT_IS_MANDATORY_TO_SELECT_AT_LEAST_ONE_ACTIVITY_OR_SESSION',
    passwordsDoesNotMatch = 'PASSWORDS_DOES_NOT_MATCH',
    passwordHasBeenChanged = 'PASSWORD_HAS_BEEN_CHANGED',
    checkYourEmailInboxForPasswordResetLink = 'CHECK_YOUR_EMAIL_INBOX_FOR_RESET_PASSWORD_LINK',
    isThisEmailHasAnAccountAnEmailWithALoginLinkHasBeenSent = 'IF_THIS_EMAIL_HAS_AN_ACCOUNT_AN_EMAIL_WITH_A_LOGIN_LINK_HAS_BEEN_SENT',
    resetPassword = 'RESET_PASSWORD',
    createAccount = 'CREATE_ACCOUNT',
    checkYourEmailInboxForCreateAccountLink = 'CHECK_YOUR_EMAIL_INBOX_FOR_CREATE_ACCOUNT_LINK',
    paymentSucceeded = 'PAYMENT_SUCCEEDED',
    paymentDidNotSucceed = 'PAYMENT_DID_NOT_SUCCEED',
    transactionCancelled = 'TRANSACTION_CANCELLED',
    accessCodeNotProvided = 'ACCESS_CODE_NOT_PROVIDED',
    incorrectAccessCode = 'INCORRECT_ACCESS_CODE',
    ingenicoPaymentDidNotSucceed = 'INGENICO_PAYMENT_DID_NOT_SUCCEED',
    loginLink = 'LOGIN_LINK',
}

export const enum SideMenuItemId {
    myProfile = 'myProfile',
    // myEvents = 'myEvents',
    events = 'events',
    requests = 'requests',
    myOrders = 'myOrders',
    myOrganization = 'myOrganization',
    changePassword = 'changePassword',
    subscriptions = 'subscriptions',
    logout = 'logout'
}

export type TranslationMapKey = keyof typeof TRANSLATIONS | TranslationKey;
export type TranslationMap = {[Key in TranslationMapKey]: Key};
export const TRANSLATION_MAP: TranslationMap = Object.keys(TRANSLATIONS).reduce((record, key) => ({
    ...record,
    [key]: key
}), {} as TranslationMap);

export enum DateConversion {
    myTime = 'my-time',
    objectTime = 'object-time'
}

export const enum FieldAttributeTranslationValue {
    tooltipTranslation = 'TOOLTIP_TRANSLATION',
    placeholderTranslation = 'PLACEHOLDER_TRANSLATION',
    errorMessageTranslation = 'ERROR_MESSAGE_TRANSLATION',
    labelTranslation = 'LABEL_TRANSLATION',
}

export const enum RevereAttributeName {
    dataTokenizationKey = 'data-tokenization-key',
    dataVariant = 'data-variant',
    dataStyleSniffer = 'data-style-sniffer'
}

export const enum RevereDataVariantAttributeValue {
    inline = 'inline',
    lightbox = 'lightbox',
}
